import styled from "styled-components";

export const PageContainer = styled.div`
	height: auto;
	width: 100%;
	max-width: 900px;
`;
